import React from 'react';
import InPageHeaderShapesAltNav from '../../components/media/InPageHeaderShapesAltNav';
import LargeFeaturedImgAlt from "../../components/media/LargeFeaturedImgAlt";
import HawthorneMuseumImg from "../../images/Hawthorne-Historical-Museum-1.jpg";
import { Container, Row, Col } from 'react-bootstrap';
import Footer from '../../components/Footer';
import bgShapesImage from "../../images/shapes-inpage-header.png";
import NavigationAlt from '../../components/NavigationAlt';

class Calendar extends React.Component {
    render() {
        return (
       
          <main className="calendar">
             <NavigationAlt />

             <Container textAlign='center'>
             <Row className='cal-row'>
                <Col xs={12}>
                <h1 className='cal-title'>Calendar of Events</h1>
                </Col>
            
              <Col xs={12}>
              <h2 className='cal-subheading'>Attend One of Our Upcoming Events</h2>
              </Col>
              </Row>
             </Container>

             <Container className='accrp-calendar'>
            
              
              <Row>
                <div data-tockify-component="calendar" data-tockify-calendar="actruth"></div>
              </Row>
             </Container>
            <InPageHeaderShapesAltNav
             inPageBGImage={bgShapesImage}
           /*   pageHeading={"Calendar of Events"}
             pageSubHeading={"Attend One of Our Upcoming Events"} */
             optionalComponent={<LargeFeaturedImgAlt imgSrc={HawthorneMuseumImg} imgAlt={"Image of Hawthorne Museum"} />}
             />
            

            <Footer />
          </main>
        );
    };
}

export default Calendar;